import { apiV2 } from "../http";

type ResponseSimulatorStatus = 0 | 1 | 2;
type SimulationState = "success" | "failed" | "unverified" | "skipped";

const SIMULATION_STATE_DICTIONARY: Record<ResponseSimulatorStatus, SimulationState> = {
  0: "failed",
  1: "success",
  2: "unverified",
};

export interface ResponseSimulatorSuperform {
  deposit_status: ResponseSimulatorStatus;
  withdraw_status: ResponseSimulatorStatus;
}

export interface VaultSimulationState {
  deposit?: SimulationState;
  withdraw?: SimulationState;
  status: "success" | "error" | "skipped";
  error?: string;
}
export async function getSuperformSimulation(superformId: string): Promise<VaultSimulationState> {
  return apiV2
    .rawRequest<any, ResponseSimulatorSuperform>({
      method: "GET",
      url: `/simulator/superform/${superformId}/`,
    })
    .then(({ data, status }) => {
      if (status < 200 || status > 299) {
        return {
          status: "skipped",
          error: `We were unable to run the simulation. ${
            status === 400 ? "We were unable to run the simulation. Provided superform ID is invalid." : "This is likely an issue with our simulation provider."
          }`,
        };
      }

      if (!data) {
        return {
          status: "skipped",
          deposit: "skipped",
          withdraw: "skipped",
        };
      }

      return {
        status: data.deposit_status === 1 && data.withdraw_status === 1 ? "success" : data.deposit_status === 0 || data.withdraw_status === 0 ? "error" : "skipped",
        deposit: SIMULATION_STATE_DICTIONARY[data.deposit_status],
        withdraw: SIMULATION_STATE_DICTIONARY[data.withdraw_status],
      };
    });
}
